import React from "react";

interface LineChartProps {
  data: number[];
  color?: string;
}

export const LineChart = ({ data, color = "#2E90FA" }: LineChartProps) => {
  // Generate path from data points
  const maxValue = Math.max(...data, 1);
  const points = data
    .map((value, index) => {
      const x = (index / (data.length - 1)) * 100;
      const y = 30 - (value / maxValue) * 20; // Scale to fit in the 30px height
      return `${x.toString()},${y.toString()}`;
    })
    .join(" L ");

  const pathD = `M${points}`;
  const areaPathD = `${pathD} L100,30 L0,30 Z`;

  return (
    <div className='w-full h-full flex items-center justify-center'>
      <svg viewBox='0 0 100 30' className='w-full h-full overflow-visible'>
        <path d={pathD} fill='none' stroke={color} strokeWidth='1.5' />
        <path d={areaPathD} fill='white' stroke='none' />
      </svg>
    </div>
  );
};
